import { createAction } from '@reduxjs/toolkit';

import { mbcClassEntryModule } from '../constants';

export const routeMBCClassEntry = createAction(
  `${mbcClassEntryModule}/ROUTE_MBC_CLASS_ENTRY`,
);

export const ROUTE_MBC_CLASS_ENTRY = routeMBCClassEntry.type;
